<template>
  <div class="club-points-history-table">
    <mobile-row
      v-for="(record, index) in historyRecords"
      :key="index"
      :points="record.bonusesUsed"
      :date="formatDate(record.date)"
      :is-add-mode="record.bonusesUsed > 0"
      :sum="record.bonusesTotal"
      :description="record.description"
      :burns-at="formatDate(record.dateEnd)"
      :order-number="record.orderNumber"
      :receipt="record.receipt"
    />
  </div>
</template>

<script>
import { ddmmyyyy } from '@/utils/date-to-string';
import MobileRow from '@/components/account/club-table/club-points-history-table-row.vue';

export default {
  name: 'club-points-history-table',

  components: {
    MobileRow,
  },

  props: {
    historyRecords: {
      type: Array,
      default: () => [],
    }
  },

  methods: {
    formatDate(dateISOstring) {
      return ddmmyyyy(new Date(dateISOstring));
    },
  },
}
</script>